module.exports = __webpack_public_path__ + "static/media/home.f967c843.png";